import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

import { scrollDashboardToTop } from "./useScrollOnTabChange";

const useScrollToTop = () => {
  const location = useLocation();

  useLayoutEffect(scrollDashboardToTop, [location.pathname, location.search, location.hash]);
};

export default useScrollToTop;
